import { assetContactMessage, periodMonthLower, periodOf, SHARE_TOKEN_PATTERN, whatsappLinks, type PublicAsset } from "@fusiqo/vozqi-shared";

/**
 * What the public page of an object's history computes, as plain functions
 * (spec bitácora por enlace §9.2): the page itself only draws.
 */

/** `/e/<token>` → the token, when it has the shape one has; anything else is null. */
export function tokenFromAssetPath(pathname: string): string | null {
  const match = /^\/e\/([^/]+)\/?$/.exec(pathname);
  const token = match?.[1];
  return token !== undefined && SHARE_TOKEN_PATTERN.test(token) ? token : null;
}

/** A photo, through the Worker's own path: the page never sees a storage address. */
export function assetPhotoSrc(token: string, attachmentId: string, size: "thumb" | "full"): string {
  return `/e/${token}/foto/${attachmentId}${size === "thumb" ? "?t=thumb" : ""}`;
}

/** «Escribir por WhatsApp», to the workshop's own number about this object. Null without one: no button. */
export function assetWhatsappHref(view: PublicAsset): string | null {
  if (view.business.whatsapp === null) return null;
  return whatsappLinks(view.business.whatsapp, assetContactMessage(view.asset.label)).web;
}

/** «Próximo mantenimiento: limpieza, marzo 2027»: the month, never the day, on a stranger's page. */
export function nextLine(next: NonNullable<PublicAsset["next"]>): string {
  const what = next.label.charAt(0).toLowerCase() + next.label.slice(1);
  return `Próximo mantenimiento: ${what}, ${periodMonthLower(periodOf(next.on))} ${next.on.slice(0, 4)}`;
}
